import axios from 'axios';
import { isInt } from './util/helpers';
import { lockScroll, unlockScroll } from './util/scroll-lock';

window.addEventListener('load', () => {
    let isProcessing = false;

    document.querySelectorAll('.newsletter-sign-up').forEach(newsletterForm => {
        newsletterForm.addEventListener('submit', e => {
            e.preventDefault();

            if (isProcessing) {
                return;
            }

            let button = newsletterForm.querySelector('.button');
            let notification = newsletterForm.querySelector('.notification');
            const formData = new FormData(e.target);

            isProcessing = true;

            button.classList.add('loading');
            notification.classList.add('hidden');
            notification.classList.remove('success', 'error');

            axios.post('/wp-json/atyu/newsletter', {
                email: formData.get('email'),
            }).then(() => {
                notification.classList.add('success');
                notification.textContent = 'Thank you for signing up to our newsletter.';
                newsletterForm.reset();

            }).catch(errors => {
                const error = errors.response.data;

                notification.classList.add('error');
                notification.textContent = error.detail;

            }).finally(() => {
                isProcessing = false;

                button.classList.remove('loading');
                notification.classList.remove('hidden');
            });
        });
    });

    if (
        localStorage.getItem('hide_newsletter_modal')
        || sessionStorage.getItem('hide_newsletter_modal')
        || ! isInt(newsletterModalDelay)
        || newsletterModalDelay <= 0
    ) {
        return;
    }

    setTimeout(() => {
        lockScroll();

        let modal = document.querySelector('.newsletter-modal');
        let modalContent = modal.querySelector('.modal-content');
        let hideModalButton = modal.querySelector('.hide-modal');
        let modalBackground = modal.querySelector('.modal-background');

        let timeline = gsap.timeline({
            onReverseComplete() {
                unlockScroll();
                modal.classList.remove('active');
            },
        });

        modal.classList.add('active');

        timeline.to(modalBackground, {
            opacity: 1,
            duration: 0.25,
        }).to(modalContent, {
            opacity: 1,
            duration: 1,
            translateY: 0,
            ease: 'elastic.inOut',
        }, '-=0.15');

        [modalBackground, hideModalButton].forEach(element => {
            element.addEventListener('click', () => {
                hideModal(timeline);
            });
        });

        document.addEventListener('keydown', e => {
            if (e.key === 'Escape' && modal.classList.contains('active')) {
                hideModal(timeline);
            }
        });
    }, newsletterModalDelay * 1000);
});

const hideModal = timeline => {
    sessionStorage.setItem('hide_newsletter_modal', 'true');
    timeline.reverse();
};

// const setLocalStorage = () => {
//     localStorage.setItem('hide_newsletter_modal', 'true');
// };
